import * as React from 'react'
import { graphql } from 'gatsby'
import Club from 'components/club'
import MetaInfo from '../components/ui/meta-info'

const ClubPage = ({
  data: {
    clubContent: { content },
  },
  location,
}) => {
  return <Club location={location} data={content} />
}

export default ClubPage

export const Head = () => <MetaInfo title={'The Amenities'} />

export const query = graphql`
  query ClubQuery {
    clubContent {
      content {
        anchorID
        sectionClass
        color
        mobileColor
        anchors {
          firstList {
            divider
            anchor
            text
            url
            scrollToID
          }
        }

        contentList {
          align
          color
          description
          subtitle
          size
          rowDirection
          subtitle
          title
          width
          mobileColor
        }
        copyContent {
          align
          description
          subtitle
          title
          color
          rowDirection
          size
          width
          mobileColor
        }
        description
        heroSection
        multiColumn
        heroSectionClassName
        link
        subtitle
        title
        type
        anchorID
        images {
          alt
          caption
          file {
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`
